import NewRelicBrowser from '@/plugins/newrelic-browser.ts';

export type AuthReadinessOutcome = 'ready' | 'failed' | 'timeout' | 'cancelled' | 'denied';

type AuthReadinessAttemptOptions = {
    admissionRequired: boolean;
    authenticatedAtStart: boolean;
    contextRequired: boolean;
    deadlineMs: number;
    fetchRequired: boolean;
    retryBudgetMs: number;
};

const ATTEMPT_ACTION = 'auth_readiness_attempt';
const OUTCOME_ACTION = 'auth_readiness_outcome';

export function startAuthReadinessAttempt(
    options: AuthReadinessAttemptOptions,
    now: () => number = () => performance.now(),
    addPageAction: (actionName: string, attributes: Record<string, unknown>) => void = (
        actionName,
        attributes
    ) => NewRelicBrowser.addPageAction(actionName, attributes)
): (outcome: AuthReadinessOutcome) => void {
    const startedAt = now();
    let finished = false;

    try {
        addPageAction(ATTEMPT_ACTION, options);
    } catch {
        // Optional telemetry must never interrupt authentication.
    }

    return (outcome: AuthReadinessOutcome): void => {
        if (finished) {
            return;
        }
        finished = true;

        try {
            addPageAction(OUTCOME_ACTION, {
                ...options,
                durationMs: Math.max(0, Math.round(now() - startedAt)),
                outcome,
            });
        } catch {
            // Optional telemetry must never interrupt authentication.
        }
    };
}
